import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { FeaturesProperties } from "@/types/features";
import { settingsFromApiApplied } from "@/store/settings/settingsFlowActions";

const initialState = {
  data: null as Partial<FeaturesProperties> | null,
};

const featuresSlice = createSlice({
  name: "features",
  initialState: initialState,
  reducers: {
    updateFeatures: (
      state,
      action: PayloadAction<Partial<FeaturesProperties>>,
    ) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(settingsFromApiApplied, (state, action) => {
      const next = action.payload.features;
      if (next == null) {
        return;
      }
      state.data = next;
    });
  },
});

export const { updateFeatures } = featuresSlice.actions;
export default featuresSlice.reducer;
